
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm`}>
      <div className="max-w-7xl mx-auto px-6 py-1">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img 
              src="/images/Logo_CandyVoice.png" 
              alt="CandyVoice Logo" 
              className="h-[72px] w-auto object-contain"
            />
          </div>
          <div className="flex items-center gap-6">
            <a href="#about" className="text-[18.2px] font-medium transition-colors hover:text-[#F3220B] text-gray-700">
              About
            </a>
            <a href="#demo" className="text-[18.2px] font-medium transition-colors hover:text-[#F3220B] text-gray-700">
              Demo
            </a>
            <a href="#recognition" className="text-[18.2px] font-medium transition-colors hover:text-[#F3220B] text-gray-700">
              Awards
            </a>
            <a href="#partners" className="text-[18.2px] font-medium transition-colors hover:text-[#F3220B] text-gray-700">
              Partners
            </a>
            <a href="#contact" className="text-[18.2px] font-medium transition-colors hover:text-[#F3220B] text-gray-700">
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
